import { partnersAPI } from '@/providers/apis/partners/partners';
import { COLLABORATOR_TYPES } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';
import PartnersBarChart from '../charts/partners-bar-chart/partners-bar-chart';

@Component({
    name: 'collaborators-pullup',
    components: {
       'partners-bar-chart' : PartnersBarChart,
    },
})

export default class CollaboratorsPullup extends Vue {


    // ------------------------------------------------------------
    // Properties

    private rangePicker: Array<{name: string, key: string}> = [
        {
            name: 'Last 3 Month',
            key: 'last_three_month',
        },
        {
            name: 'Last 6 Month',
            key: 'last_six_month',
        },
        {
            name: 'Last 12 Month',
            key: 'last_year',
        },
        {
            name: 'Till Now',
            key: 'overall',
        },
    ];

    private activeRange: {name: string, key: string} = this.rangePicker[3];

    private chartData: Array<{name: string, count: number, type: string}> = [];

    private partners: any = [];

    private partnerTypes: any  = COLLABORATOR_TYPES;

    private activeType: any = null;

    private isLoading: boolean = false;

    private totalPartners: number = 0;


    // ------------------------------------------------------------
    // Hooks

    private created() {
        this.fetchPartnersDetail();
    }

    // ------------------------------------------------------------
    // Actions

    private onSelectRange(range: {name: string, key: string}) {
        this.activeRange = range;
    }

    private onSelectType(selectedType: any) {
        const partnerEl = this.$el.querySelector(`#${selectedType.type}`);
        this.activeType = selectedType;
        partnerEl!.scrollIntoView({behavior: 'smooth'});
    }

    // -------------------------------------------------------------
    // Methods

    private fetchPartnersDetail() {
        this.isLoading = true;
        partnersAPI.getPartners().then((response) => {
            this.partners = response;
            this.isLoading = false;
            this.parsePartnersData(response);
          });
    }

    private parsePartnersData(partnersList: any) {
        const partnersType = Object.keys(partnersList);
        let totalCount = 0;
        partnersType.forEach((type) => {
            if (this.partnerTypes[type]) {
                totalCount += partnersList[type].length;
                this.chartData.push({
                    name: this.partnerTypes[type],
                    count: partnersList[type].length,
                    type,
                });
            }
        });
        this.totalPartners = totalCount;
        this.activeType = this.chartData[0];
    }
}
